import { useEffect, useState } from "react";
import { useCompanyLogo } from "./api/company";
import { useUser } from "./api/user";
import { toastError } from "../../helpers/toast-helper";
import { getResponseItemData } from "../../helpers/response-helper";
import { TLineItemCategory } from "../types/line-item-category";
import { TQuoteDetails, TQuoteLineItem} from "../types/quote";
import generateAndDownload from "../../helpers/quote-pdf";

interface GeneratePdfProps {
    lineItemsCategoryList: TLineItemCategory[],
    lineItems: TQuoteLineItem[];
    quote: TQuoteDetails;
    totalArea: number;
}

const useQuotePdf = () => {
    const [isDataNeeded, setIsDataNeeded] = useState(false);
    const [pdfProps, setPdfProps] = useState<GeneratePdfProps | null>();
    const [companyLogo, setCompanyLogo] = useState<Blob | null | undefined>();
    const { data: userResponse, isLoading: isUserDataLoading } = useUser(pdfProps?.quote?.userId, {
        enabled: isDataNeeded && !!pdfProps?.quote?.userId,
        onError: () => {
            toastError("Cannot fetch user data");
        },
    });

    const { data } = getResponseItemData(userResponse);

    const { isLoading: isCompanyLogoLoading } = useCompanyLogo(data?.company?.id, {
        enabled: isDataNeeded && !!data?.company?.id,
        onSuccess: (data) => {
            setCompanyLogo(data);
        },
        onError: () => {
            setCompanyLogo(null);
        },
    });

    const generatePdfAndDownload = (props: GeneratePdfProps) => {
        setIsDataNeeded(true);
        setPdfProps(props);
    };

    useEffect(() => {
        if (pdfProps && data && (!data.company?.id || companyLogo !== undefined)) {
            generateAndDownload({
                ...pdfProps,
                user: data,
                companyLogo: companyLogo || null,
            });
        }
    }, [pdfProps, data, companyLogo]);

    return {
        generatePdfAndDownload,
        isLoading: isCompanyLogoLoading || isUserDataLoading,
    };
};

export default useQuotePdf;
